"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePhoneNumberRequest = void 0;
var UpdatePhoneNumberRequest_1 = require("./UpdatePhoneNumberRequest");
Object.defineProperty(exports, "UpdatePhoneNumberRequest", { enumerable: true, get: function () { return UpdatePhoneNumberRequest_1.UpdatePhoneNumberRequest; } });
